import React, { FC, useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import { ItemTitleProps } from "../common/types";
import { Heading } from "@pepdirect/ui/heading";
import { CartItem } from "services/graphql/generated";
import { ExternalLink } from "@pepdirect/ui/ExternalLink";

const StyledItemTitle = styled.div`
  padding-bottom: 5px;
  font-family: AktivGrotesk Ex Black Italic, Arial, sans-serif !important;
  text-transform: uppercase;
  font-size: 28px !important;
`;

export const ItemTitle: FC<ItemTitleProps> = ({
  product,
  fallbackUrl,
  isLink = true,
  cmsProducts,
}) => {
  const theme = useContext(ThemeContext);
  const itemSlug = cmsProducts?.find(
    (cmsProduct) => cmsProduct.gtin === (product as CartItem["item"]).gtin
  )?.slug;

  return (
    <StyledItemTitle>
      {isLink && (
        <ExternalLink
          openInSameTab={true}
          href={`${fallbackUrl}/products/${itemSlug}`}
        >
          <Heading level="h2" size="m" color={theme.color.primary}>
            {product.title}
          </Heading>
        </ExternalLink>
      )}
      {!isLink && (
        <Heading level="h2" size="m" color={theme.color.primary}>
          {product.title}
        </Heading>
      )}
    </StyledItemTitle>
  );
};
